const lang = {
	/* all string  for languages */


	/* nav bar */ 

	DISPATCH_ORDER:"Dispatch",
	ACCEPT_ORDER:"Accept",
	MANAGE :"Manage",
	
	NOTE:"Note",

	/* Wholesaler Registration form */ 
	FIRM_NAME:"Firm Name",
	NAME:"Name",
	PHONE_NUMBER:"Phone Number",
	ALTERNATE_PHONE_NUMBER:"Alternate Phone Number",
	MOBILE_NO:"Mobile Number",
	LANDLINE_NO:"Landline Number",
	EMAIL_ID:"Email ID",
	PASSWORD:"Password",
	CONFIRM_PASSWORD:"Confirm Password",
	SHOP_NO:"Shop Number",
	PIN_CODE:"Pincode",
	FULL_ADDRESS:"Full Address",
	CITY:"City",
	STATE:"State",
	GST_NUMBER:"GST Number",
	LOCATION:"Location",
	AADHAAR_NUMBER:"Aadhaar Number",
	DL_NUMBER:"DL Number",
	DL_EXPIRY:"DL Expiry",
	ASSETS:"Assets",
	BANK_NAME:"Bank Name",
	ACCOUNT_NUMBER:"Account Number",
	ACCOUNT_HOLDER_NAME:"Account Holder Name",
	IFSC:"IFSC",
	PAN_CARD:"PAN Card",
	CREDIT_LIMIT:"Credit Limit",


	CONTINUE:"Continue", 
	OK:"OK", 
	SKIP:"Skip", 
	SUCCESS:"Success", 
	LOGIN:"Login", 
	SING_UP:"Sing up", 
	RESEND_TO:"Resend to ",
	LOGOUT:"Logout ",
	NEXT:"Next",
	GET_STARTED:"Get Started",
	FORGOT_PASSWORD:"Forgot Password?",
	ENTER_6_DIGIT_CODE:"Enter the 6-digit code sent to",


	/* overview*/ 
	RECENT_ORDERS:"Recent orders",
	SHIPMENTS:"Shipments",
	OUT_FOR_DELIVERY:"Out for delivery",
	DELIVERED:"Delivered",
	NEW_ORDERS:"New orders",
	PICKED_UP_TODAY:"Picked up today",
	TO_BE_RETURNED:"To be returned",
	RETURNED:"Returned",
	IN_WALLET:"In Wallet",
	LIVE_AGENTS:"Live Agents",
	PAYMENTS:"Payments",
	PENDING_CONFIRMATION:"Pending Confirmation",
	AT_WAREHOUSE:"At Warehouse",


	NEW_SHIPMENT:"New Shipment",

	/* Shipment   */ 
	DOWNLOAD_CSV:"Download CSV",
	FILTER:"Filter",
	CREATE_BULK_ORDER:"Create Bulk Order",
	NEW_RETAILER:"New Retailer",
	RETAILER:"Retailer",
	RETAILER_TYPE:"Retailer Type",
	AREA:"Area",
	CHALLAN_NUMBER:"Challan Number",
	SHIPMENTS_DETAILS:"Shipments Details",
	NUMBER_OF_PACKETS:"Number of Packets",
	PAYMENT_DETAILS:"Payment Details",
	AMOUNT:"Amount",
	METHOD:"Method",
	CASH:"Cash",
	CREDIT:"Credit",
	TOTAL:'Total',
	ADD_SHIPMENT:'Add Shipment',
	RE_ASSIGN:'Re-assign',
	LIST_OF_RETAILER:"List of Retailer",
	ADD_NEW_RETAILER:"Add New Retailer",
	SELECT_FROM_EXISTING_LIST:"Select from Existing List",
	REFRESH:"Refresh",

	/* shipment tracking*/ 
	SHIPMENT_TRACKING:"Shipment Tracking",
	SHIPMENT_ID:"Shipment ID",
	WHOLESALER_DETAILS:"Wholesaler Details",
	RETAILER_DETAILS:"Retailer Details",
	RETAILER_INFO:"Retailer Info",
	PICKUP_AGENT:"Pickup Agent",
	DELIVERY_AGENT:"Delivery Agent",
	PACKETS:"Packets",
	MODE:"Mode",
	DELIVERY_MODE:"Delivery Mode",
	CANCEL_ORDER:"Cancel Order",
	SHARE:"Share",
	PRINT:"Print",
	SUPPORT:"Support",
	TRACK:"Track",
	DROPED_AT:"Dropped At",


	FILTER_SHIPMENT:"Filter Shipments",
	FILTER_USING:"Filter Using",
	FILTER_SELECTED:"Filters Selected",
	CLEAR_ALL:"Clear All",
	APPLY:"Apply",
	SEARCH:"Search",
	ADD:"Add",
	FROM:'From',
	TO:'To',
	DAY:"Day",
	MONTH:"Month",
	YEAR:"Year",
	FROM_DATE:"From Date",
	TO_DATE:"To Date",
	SELECT:"Select",

	/* Accept shipment*/
	REQUESTS:"Requests",
	DROP_SHIPMENT:"Drop Shipment",
	AUTO_ASSIGN:"Auto Assign",
	ACCEPT:"Accept",
	ASSIGN:"Assign",
	ASSIGN_TO:"Assign to",
	PACKAGES:"Packages",
	WHOLESALER:"Wholesaler",
	WHOLESALER_INFO:"Wholesaler Info",
	SELECT_PICKUP_AGENT:"Select Pickup Agent",
	VIEW_DISPATCH_HISTORY:"View Dispatch History",
	DISPATCH:"Dispatch",
	LINE:"Line",
	BY:"By",
	DROP:"Drop",
	ASSIGN_PICKUP_AGENT:"Assign Pickup Agent",
	ASSIGN_DELIVERY_AGENT:"Assign Delivery Agent",
	SELECT_DELIVERY_AGENT:"Select Delivery Agent",
	SELECT_WHOLESALER:"Select Wholesaler",
	TRIP_ID:"Trip ID",
	ASSIGNED_ON:"Assigned On",
	COMPLETED_ON:"Completed On",
	DELIVERY_AGENT_DETAILS:"Delivery Agent Details",
	TOTAL_AMOUNT:"Total Amount",
	COLLECTION_AMOUNT:"Collection Amount",
	NUMBER_OF_STOPS:"Number of Stops",
	RECEIVED_BY:"Received By",
	NO_OF_SHIPMENT_ALLOWED:"No of Shipments Allowed",
	PLAN:"Plan",
	SUMMARY:"Summary",
	NUMBER_OF_DAYS:"Number of Days",
	NUMBER_OF_SHIPMENT:"Number of Shipment",



	/*  wholesler user profile*/ 
	ADD_A_WHOLESALER:'Add a Wholesaler',
	VIEW_DETAILS:'View Details',
	FAQS:'FAQs',
	CONTACT_US:'Contact Us',
	SAVE:'Save',
	EDIT:"Edit",
	ENABLED:"Enabled",
	DISABLED:"Disabled",
	MOBILE_PREFIX:'+91-',
	ACCESS:"Access",


	/* Raise an Issue */
	RAISE_AN_ISSUE:"Raise an Issue",
	CATEGORY:"Category",
	DESCRIPTION:"Description",
	ISSUE_ID:"Issue ID",
	RAISED_ON:"Raised On",
	RESOLVED_ON:"Resolved On",
	COMMENTS:"Comments",
	TYPE_COMMENT:"Type a comment...",
	CLOSE_TICKET:"Close Ticket",


	/*wallet  */ 
	TOTAL_RETURNS:"Total Returns",
	CURRENT_BALANCE:"Current Balance",
	WITHDRAW:"Withdraw",
	WITHDRAWAL_HISTORY:"Withdrawal History",
	WITHDRAWAL_HISTORY_FILTER:"Withdrawal History Filter",
	TRANSACTION_ID:"Transaction ID",
	TRANSACTION_DATE:"Transaction Date",
	COD_AMOUNT:"COD Amount",
	TRANSACTION_TYPE:"Transaction Type",
	EXECUTED_ON:"Executed on",
	OTP:"otp",
	DOWNLOAD:"Download",
	TIME:"Time",
	TIMER:"Timer",
	RETURNS:"Returns",
	IN_TRANSIT:"In Transit",
	/* Withdrawal */
	INITIATE_WITHDRAWAL:"Initiate withdrawal",
	VERIFICATION:"Verification",
	DATE:"Date",
	RECIPIENT_NAME:"Recipient Name",
	ENABLE_PAYOUT:"Enable Payout",
	DISABLE_PAYOUT:"Disable Payout",
	INITIATE_PAYOUT:"Initiate Payout",
	SELECT_ALL:"Select all",
	DEDUCTION_AMOUNT:"Deduction Amount",
	DEDUCTION_REASON:"Deduction Reason",
	TOTA_EARNING:"Tota Earning",
	TDS:"TDS",
	TRANSACTION_CHARGE:"Transaction Charge",
	TRANSACTION_SUMMARY:"Transaction Summary",



	// Walletfilter

	FILTER_WALLET:"Filter Wallet",


	/*Product */ 
	ADD_PRODUCT:"Add Product",
	UPLOAD_CSV:"Upload CSV",
	PRODUCT_DETAILS:"Product Details",
	PRODUCT_NAME:"Product Name",
	MANUFACTURER:"Manufacturer",
	FARMULA:"Formula",
	OFFER:"Offer",
	UPLOAD:"Upload",
	MRP:"MRP",



	/* SUbscription  */

	CURRENT_PLAN:"Current Plan",
	DAYS_REMAINING:"Days Remaining",
	SHIPMENT_REMAINING:"Shipment Remaining",
	VALIDITY:"Validity",
	CHANGE_PLAN:"Change Plan",
	BUY:"Buy",
	PRICE:"Price", 
	FOR:"for",
	DAYS:"Days",
	SUBSCRIPTION_HISTORY:"Subscription History",
	CREATE_NEW_PLAN:"Create A New Plan",
	PLAN_DETAILS:"Plan Details",
	GST:"GST %",
	GST_TEXT:"GST",
	PAYMENT_METHODS:"Payment Methods",
	APPROVE_SUBSCRIPTION:"Approve Subscription",
	ADD_NEW_SUBSCRIPTION:"Add New Subscription",
	SUBSCRIBER_DETAILS:"Subscriber Details",
	PLAN_TYPE:"Plan type",
	ADDON_TYPE:"Add-on type",
	PAYMENT_LINK:"Payment Link",


	/* popups*/ 
	ARE_YOU_SURE:"Are you sure",
	ARE_YOU_SURE_DELETE:"Are you sure want to delete",
	ARE_YOU_SURE_CANCEL_SHIPMENT:"Are you sure want to Cancel Shipment",
	ARE_YOU_SURE_BLOCK_AGENT:"Are you sure want to block agent",
	ARE_YOU_SURE_ACTIVATE_AGENT:"Are you sure want to activate agent",


	/* Retailers*/ 
	UPLOAD_AN_IMAGE:"Upload an Image",
	ADD_A_PHOTO_OF_SHOP_FRONT:"Add a photo of Shop Front",
	ADD_A_RETAILER:"Add a Retailer",
	MERGE_WITH:"Merge with",
	MERGE:"Merge",
	MERGE_MSG:"All the associated transactions will be moved to the below selected retailer",


	/* Agents */
	EMPLOYEE_DETAILS:"Employee Details",
	UPLOAD_DOCUMENTS:"Upload Documents",
	TYPE:"Type",
	DOCUMENT:"Document",
	ADD_AN_AGENT:"Add an Agent",
	VIEW_PAYOUT:"View Payout",

	/* warehouse*/ 
	WAREHOUSE:"Warehouse",
	ADD_WAREHOUSE:"Add Warehouse",
	WAREHOUSE_NAME:"Warehouse Name",
	WAREHOUSE_DETAILS:"Warehouse Details",
	COLLECT:"Collect",
	COLLECTION_SHIPMENT:"Collection Shipment",
	VIEW_COLLECTION_HISTORY:"View Collection History",


	/* Line */
	ADD_A_LINE:"Add a Line" ,
	LINE_DELIVERY_TIME:"Line Delivery Time" ,
	LINE_ID:"Line ID" ,
	LINE_NAME:"Line Name" ,
	CHEQUE_NUMBER:"Cheque number",
	NEFT_TRANSACTION_ID:"IMPS/NEFT Transaction ID",
	CONFIRM:"Confirm",
	REJECT:"Reject",
	APPROVE:"Approve",
	STATUS:"Status",


	YOUR_ID_IS_BLOCKED:"Your id is blocked",
	BLOCKED_MSG:"Your id is blocked or deleted by warehouse admin, Please contact for more information.",

	YY_MM_DD:"yyyy-mm-dd",


	/* search lable */ 
	TICKET_SEARCH:"Search by Ticket ID, Shipment ID",
	SHIPMENT_SEARCH:"Search by Shipment ID, Challan number, Retailer name",
	ACCEPT_SHIPMENT_SEARCH:"Search by Challan number, Retailer name, Wholesaler firm name, Pickup agent name",
	WITHDRAWAL_SERCH:"Search by Transaction ID, Wholesaler firm name",
	TRIP_SEARCH:"Search by Trip ID, Delivery agent ",
	SUBSCRIPTION_SEARCH:"Search by Plan name",
	WHOLESALER_SEARCH:"Search by Wholesaler name",
	RETAILER_SEARCH:"Search by Retailer name, Mobile number",
	PRODUCT_SEARCH:"Search by Product name, Manufacturer, Formula",
	PAYOUT_SEARCH:"Search by Transaction ID, Employee name, Amount",
	WAREHOUSE_SEARCH:"Search by Warehouse name",
	COLLECTION_SEARCH:"Search by Transaction ID, Delivery agent, Reciever name",
	LINE_SEARCH:"Search by Line name",
	WALLET_SEARCH:"Search by Transaction ID",
	AGENT_SEARCH:"Search by Agent name, mobile number",

	SUBSCRIPTION_HISTORY_SEARCH:"Search by Transaction ID, Plan name, NEFT ID, Cheque number",
	
	NO_RETAILER_LEFT:"No retailer left to assign line",
	NO_RETAILER_FOUND:"No retailer found",

	COLLECTION_OTP_NOTES:"OTP can be obtained from the deposit details section in the delivery agent app.",
	WITHDRAWAL_OTP_NOTES:"OTP can be obtained from the withdrawal details section in the wholesaler app.",


	/* Empty state text*/ 
	EMPTY_SHIPMENTS:"No Shipment found",
	EMPTY_TRANSACTION:"No Transaction found",
	EMPTY_TICKET:"Ticket Not Found",
	EMPTY_PRODUCT:"No Product Found",
	EMPTY_RETAILER:"No Retailer Found",
	EMPTY_AGENT:"No Agent Found",
	EMPTY_WHOLESALER:"No Wholesaler Found",
	EMPTY_SUBSCRIPTION:"No Subscription Plan Found",
	EMPTY_TRIP:"No Trip Found",
	EMPTY_COMMENT:"No Comments Found",
	EMPTY_LINE:"No Line Found",


}	

export default lang	